import React, { useCallback, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import {
  CreateContainer,
  Header,
  MainContainer,
  Services,
  Aboutus,
} from "./components";
import { useStateValue } from "./context/StateProvider";
import { getAllFoodItems } from "./utils/firebaseFunctions";
import { actionType } from "./context/reducer";

const App = () => {
  const [, dispatch] = useStateValue();

  useEffect(() => {
    document.title = "Food Easy";
  }, []);

  const fetchData = useCallback(async () => {
    const data = await getAllFoodItems();
    dispatch({
      type: actionType.SET_FOOD_ITEMS,
      foodItems: data,
    });
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <AnimatePresence exitBeforeEnter>
      <div className="w-screen min-h-0 flex flex-col bg-foodEasyLite">
        <Header />
        <main className="mt-14 md:mt-20 px-4 md:px-16 py-4 w-full flex-none min-h-0">
          <Routes>
            <Route path="/create" element={<CreateContainer />} />
            <Route path="/services" element={<Services />} />
            <Route path="/aboutus" element={<Aboutus />} />
            <Route path="/*" element={<MainContainer />} />
          </Routes>
        </main>
      </div>
    </AnimatePresence>
  );
};

export default App;
